var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appBox"},[_c('h3',[_vm._v("功能描述")]),_c('div',{staticClass:"line"}),_c('ul',[_c('li',[_vm._v("\n      红狮启富APP是香港红狮集团自主研发的专业贵金属综合性交易软件，是专属于客户的智能理财服务平台。\n    ")]),_c('li',[_vm._v("\n      APP集开户、交易、存取款、实时报价、行情播报、财经资讯、专家分析、投教学习等功能于一身，让客户的交易方式更简单，及时把握最佳盈利机遇。\n    ")])])])
}]

export { render, staticRenderFns }